import { FiMoon, FiSun } from "react-icons/fi";
import { useTheme } from "@/hooks/useTheme";
import { useTranslations } from "@/i18n";

export interface ThemeToggleProps {
  openUpward?: boolean;
}

export function ThemeToggle({ openUpward = false }: ThemeToggleProps) {
  const { theme, toggleTheme } = useTheme();
  const t = useTranslations();
  return (
    <div className="group relative">
      <button
        aria-label={t(
          theme === "dark" ? "common.theme.useLight" : "common.theme.useDark"
        )}
        aria-pressed={theme === "dark"}
        className="flex h-11 w-11 items-center justify-center rounded-lg text-muted transition-colors hover:bg-canvas hover:text-ink focus:outline-none focus-visible:ring-2 focus-visible:ring-ink"
        onClick={toggleTheme}
        type="button"
      >
        {theme === "dark" ? (
          <FiSun aria-hidden="true" className="h-5 w-5" />
        ) : (
          <FiMoon aria-hidden="true" className="h-5 w-5" />
        )}
      </button>
      <span
        className={`pointer-events-none absolute left-1/2 z-[70] -translate-x-1/2 whitespace-nowrap rounded-md bg-ink px-2 py-1 text-xs font-medium text-surface opacity-0 shadow-sm transition-opacity group-focus-within:opacity-100 group-hover:opacity-100 ${openUpward ? "bottom-[calc(100%+0.35rem)]" : "top-[calc(100%+0.35rem)]"}`}
        role="tooltip"
      >
        {t(theme === "dark" ? "common.theme.light" : "common.theme.dark")}
      </span>
    </div>
  );
}
